import { Component, Input, Output, ViewChild, EventEmitter, OnInit, ElementRef } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { UserProfileNeje } from '../../../models/user-profile-neje'
import { CommissionLevelGateway } from '../../../gateways/commission-level-gateway'
import { OrgLevelGateway } from '../../../../org-management/gateways/organization-gateway'
import { SettingGatewayGateway } from '../../../../org-management/gateways/setting-gateway'
import { OrgSettingsModel } from '../../../../org-management/models/org-settings-model'
import { EditFmoAbstractGateway } from '../../../../org-management/gateways/edit-fmo-abstract-gateway'
import { UserTypeGateway } from '../../../gateways/user-type-gateway'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { PasswordTextFieldValidator } from '../../../../validations/password-text-field-validator'
import { UserPhoneDB } from '../../../models/user-phone'
import { AddressDB } from '../../../models/address'
import { UserPersonalDetails } from '../../../models/user-personal-details'
import { UserProfileRoleOrganization } from '../../../models/user-profile-role-org'
import { User } from '../../../models/user'
import { UserProfileGateway } from '../../../gateways/user-profile-gateway'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { UserGateway } from '../../../gateways/user-gateway'
import { UserDataService } from '../../../gateways/common-data-service'
import { License } from '../../../models/license-details'
import { LicenseApptGateway } from '../../../gateways/license-appt-gateway'
import { CurrentUser } from '../../../../common/models/current-user'
import { CurrentUserGateway } from '../../../../common/gateways/current-user-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { UserCommentsGateway } from '../../../gateways/user-comments-gateway'
import { WebUserComment } from '../../../models/web-user-comments'
import * as moment from 'moment'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'

import { OrgTreeView } from '../../../../common/components/orgTreeView/orgTreeViewDropdown.Component'
import { OrgBrowserView } from '../../../../reports/models/org-browser-view'
import { NotBlankStateFieldValidator } from '../../../../validations/not-blank-state-field-validator'
import { NgModel } from '@angular/forms'

@Component({
    selector: 'NEJEAddProfile',
    templateUrl: 'add-profile.component.html',
    styleUrls: ['./add-profile.component.scss']
})
export class NEJEAddProfileComponent implements OnInit {
    user: any = {} as any
    userProfiledetail = {} as UserProfileNeje
    comments: WebUserComment[] = [] as WebUserComment[]
    commentsViewModel: WebUserComment[] = [] as WebUserComment[]
    CommentinsertModel: WebUserComment = {} as WebUserComment

    notBlankStateValidator = new NotBlankStateFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()
    zipCodeValidator = new LengthTextFieldValidator(5)
    numericValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    @ViewChild('child') private child: OrgTreeView

    org: ValidatedSelectOptionModel[]
    selectedRoleID: number
    userType: ValidatedSelectOptionModel[]
    userTypeDescription: string
    ErrorMessages: any[]
    isFormValid: boolean
    passwordValidator: PasswordTextFieldValidator = new PasswordTextFieldValidator()
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    addresses: any[] = [] as any[]
    userPhones: UserPhoneDB[] = [] as UserPhoneDB[]
    personalDetails = {} as UserPersonalDetails
    userProfileRoleOrganization = {} as UserProfileRoleOrganization
    allStates: State[] = [] as State[]
    pageTitle: string
    userProfileID = 0
    errorMessage = ''
    mode = 'add'
    isfromUserSearch: string
    phoneNumberInputMask = new PhoneNumberInputMask()
    userprofileStatus: ValidatedSelectOptionModel[]
    licenseViewModel: License[] = [] as License[]
    isAddMode: boolean
    isAdminUpdate = false
    disableLogIn: boolean
    DisabledName: boolean = false
    successOrErrorMessage: string
    ifWarnings = false
    isReadOnly = false
    Warnings: any[]
    errorlist: any[]
    errorlists: any[]
    residentialAddrID = 0
    businessAddrID = 0
    businessPhoneID = 0
    showLicenseTab = false
    licenseScreenShow = false
    validateEmpID = false
    displayEmpID = false
    currentUser: CurrentUser = {} as CurrentUser
    statusReason: ValidatedSelectOptionModel[] | null = []
    selectedUserStatus: ValidatedSelectOptionModel[]
    noMiddleName = false
    displayProfile = true
    commentsScreenShow = false
    trainingScreenShow = false
    showCommentsTab = false
    showTrainingTab = false
    displayuserstatus = false
    currentUserStatus: string
    initialOrgLoad: boolean = true

    orgSelected: OrgBrowserView = new OrgBrowserView()
    isOrgSelectHidden: boolean = true
    showCommentsLicenseTrainingSection = false
    showChangePwdNavigation = false
    showUserTypeSection = true
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private comLevelGateway: CommissionLevelGateway,
        private editFmoGateway: EditFmoAbstractGateway,
        private _userGateway: UserGateway,
        private orgLevelGateway: OrgLevelGateway,
        private settingGateway: SettingGatewayGateway,
        private userProfileGateway: UserProfileGateway,
        private _stateGateway: StateGateway,
        private userDataService: UserDataService,
        private licenseApptGateway: LicenseApptGateway,
        private curUserGateway: CurrentUserGateway,
        public _global: PortalGlobals,
        private userCommentsGateway: UserCommentsGateway,
        private userTypeGateway: UserTypeGateway
    ) {
        this.route.params.forEach((params: Params) => {
            if (params['mode']) {
                this.mode = params['mode']
            }
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
            }
            if (params['isfromUserSearch']) {
                this.isfromUserSearch = params['isfromUserSearch']
            }
        })
        if (this.mode === 'edit' && this.userProfileID === 0) {
            this.isAdminUpdate = true
            this.isAddMode = false
        }
        curUserGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
            this.currentUser = currentUserModel
            this._global.currentUser = currentUserModel
            this.OnOrgSelected(this.personalDetails.OrgID)
        })
    }

    ngOnInit() {
        if (this._global.currentUser === null || this._global.currentUser === undefined) {
            this.curUserGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
                this.currentUser = currentUserModel
                this._global.currentUser = currentUserModel
            })
        }
        this.displayEmpID = false
        this.isFormValid = true
        //this.getOrganizations()
        this.getUserTypes()
        this.getUserProfileStatus(false)
        this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
            this.allStates = states
            this.allStates.unshift({ value: 0, text: '-- Choose One --' })
            if (
                this.userProfiledetail.state === undefined ||
                this.userProfiledetail.state === '' ||
                this.userProfiledetail.state === '0' ||
                this.userProfiledetail.state === null
            ) {
                this.userProfiledetail.state = '0'
            }
        })
        if (this.mode === 'edit') {
            this.isAddMode = false
            this.disableLogIn = true
            this.pageTitle = 'Edit User Profile'
            if (this.isAdminUpdate) {
                this.DisabledName = true
                this.pageTitle = 'Update Profile'
                this.UpdateSettingsForAdmin()
                this.isReadOnly = true
                this._userGateway.retrieveAdminPersonalDetails().subscribe((model) => {
                    this.user = model
                    this.addresses = this.user.Address
                    this.userPhones = this.user.UserPhones
                    this.userProfileRoleOrganization = this.user.UserProfileRoleOrganization
                    this.personalDetails = {} as UserPersonalDetails
                    if (model.Warnings !== null && model.Warnings !== undefined) {
                        if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                            this.ifWarnings = true
                            this.Warnings = this.user.Warnings
                        }
                    }
                    this.setPersonalDetails()
                    this.setResidentialAndBussinessAddresses()
                })
            } else {
                this.UpdateSettingsForEdit()
                this.searchProfile()
            }
        } else {
            this.isAddMode = true
            this.disableLogIn = false
            this.pageTitle = 'Add Profile'
            this.userProfiledetail.ChangePassword = true
            this.UpdateSettingsForAdd()
        }
    }

    ngAfterViewInit(): void {
        if (this.isAddMode || !this.isAdminUpdate) {
            this.isOrgSelectHidden = false
        }

        if (this.isAddMode) {
            //this.child.onDataLoad('None')
        } else {
            this.userDataService.data.subscribe((data: any) => {
                //this.child.onDataLoad(data)
                this.orgSelected.orgName = data
            })
        }
    }

    UpdateSettingsForAdmin() {
        this.displayProfile = true
        this.showCommentsLicenseTrainingSection = true
        this.showChangePwdNavigation = true
        this.showUserTypeSection = false
        this.displayuserstatus = false
        this.showCommentsTab = false
        this.showLicenseTab = true
        this.displayProfile = false
        this.showTrainingTab = false
        // this.isLogInDisabled = true
        this.noMiddleName = true
    }
    UpdateSettingsForEdit() {
        this.displayProfile = true
        this.showCommentsLicenseTrainingSection = true
        this.showChangePwdNavigation = true
        // document.getElementById('divUserStatus').style.display = 'block'
        this.displayuserstatus = true

        this.showCommentsTab = true
        this.showLicenseTab = true

        this.showTrainingTab = true
    }
    UpdateSettingsForAdd() {
        this.pageTitle = 'Add User Profile'
        //  this.isReadOnly = false
        //  this.noMiddleName = false
        this.displayProfile = true
        this.displayuserstatus = false
        this.showCommentsLicenseTrainingSection = false
        this.showChangePwdNavigation = false
        this.userProfiledetail.RoleID = 0
    }
    searchProfile() {
        this._userGateway.retrieveUser(this.userProfileID).subscribe(
            (model) => {
                this.user = model
                this.addresses = this.user.Address
                this.userPhones = this.user.UserPhones
                this.userProfileRoleOrganization = this.user.UserProfileRoleOrganization
                sessionStorage.setItem('editUserOrg', this.userProfileRoleOrganization.OrgID.toString())
                this.personalDetails = {} as UserPersonalDetails
                if (model.UserProfile.UserLoginType !== null && model.UserProfile.UserLoginType.toLowerCase() === 'internal') {
                    if (model.Warnings !== null && model.Warnings !== undefined) {
                        if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                            this.ifWarnings = true
                            this.Warnings = this.user.Warnings
                        }
                    }
                }
                this.setPersonalDetails()
                this.setResidentialAndBussinessAddresses()
                this.getStatusReason(this.userProfiledetail.ProfileStatusDescription)
                // this.getUserTypes()
                //if (this.viewUserProfile.RecCreateTS !== null)
                //    this.viewUserProfile.RecCreateTSString = (moment(this.viewUserProfile.RecCreateTS)).subtract(7, 'h').format('MM/DD/YYYY hh:mm:ss A').toString()
            },
            (error) => (this.errorMessage = <any>error)
        )
    }
    setPersonalDetails() {
        this.userProfiledetail.UserProfileName = this.user.UserProfile.UserProfileName
        this.userProfiledetail.OrgID = this.user.UserProfile.OrgID = this.user.UserProfileRoleOrganization.OrgID
        this.selectedRoleID = this.userProfiledetail.RoleID = this.user.UserProfile.RoleID = this.user.UserProfileRoleOrganization.RoleDefinitionID
        this.selectedRoleID ? this.getUserTypeDesc(this.selectedRoleID.toString()) : (this.userProfiledetail.RoleID = 0)
        this.userProfiledetail.FirstName = this.user.UserProfile.FirstName
        this.userProfiledetail.LastName = this.user.UserProfile.LastName
        this.userProfiledetail.MiddleName = this.user.UserProfile.MiddleName
        if (this.user.UserProfile.MiddleName === '') {
            this.noMiddleName = true
        }
        this.userProfiledetail.Email = this.user.UserProfile.Email
        this.userProfiledetail.UID = this.user.UserProfile.UID
        this.userProfiledetail.LoginPassword = this.user.UserProfile.LoginPassword
        this.userProfiledetail.UserProfileStatusId = this.user.UserProfile.UserProfileStatusId
        this.userProfiledetail.UserProfileStatusReason = this.user.UserProfile.UserProfileStatusReason
        //this.currentUserStatus = this.userprofileStatus.find(x => x.value === this.user.UserProfile.UserProfileStatusId).text
        //this.userProfiledetail.ChangePassword = this.user.UserProfile.ChangePassword

        this.userProfiledetail.ProfileStatusDescription = this.user.UserProfile.ProfileStatusDescription
        this.currentUserStatus = this.user.UserProfile.ProfileStatusDescription

        this.userProfileID = this.userProfiledetail.UserProfileID = this.user.UserProfile.UserProfileID

        this.userProfiledetail.OrgName = this.user.UserProfile.OrgName
        this.userDataService.sendData(this.userProfiledetail.OrgName)
        this.userProfiledetail.UserLoginType = this.user.UserProfile.UserLoginType

        this.displayEmpID = this.validateEmpID = this.user.UserProfile.UserLoginType === 'Internal' ? true : false

        if (
            this.userProfiledetail.MiddleName === undefined ||
            this.userProfiledetail.MiddleName === null ||
            this.userProfiledetail.MiddleName === ''
        ) {
            this.userProfiledetail.isNoMidNameChecked = true
            this.noMiddleName = true;
        } else {
            this.userProfiledetail.isNoMidNameChecked = false
            this.noMiddleName = false
        }
    }
    setEmpIDValidation(validateEmpID: boolean) {
        this.validateEmpID = validateEmpID
    }
    setResidentialAndBussinessAddresses() {
        if (this.addresses.length > 0) {
            let currentResidentialAddress = this.addresses.filter((x) => x.AddressType === 'Home')[0]
            let currentBusinessAddress = this.addresses.filter((x) => x.AddressType === 'Business')[0]
            if (currentResidentialAddress !== null && currentResidentialAddress !== undefined) {
                this.residentialAddrID = currentResidentialAddress.AddressID
                this.userProfiledetail.addressLine2 = currentResidentialAddress.AddressLine2
                this.userProfiledetail.addressLine1 = currentResidentialAddress.AddressLine1
                this.userProfiledetail.city = currentResidentialAddress.City
                this.userProfiledetail.state = currentResidentialAddress.State
                this.userProfiledetail.zip = currentResidentialAddress.Zip
                this.userProfiledetail.zip4 = currentResidentialAddress.Zip4
            }
            if (currentBusinessAddress !== null && currentBusinessAddress !== undefined) {
                this.businessAddrID = currentBusinessAddress.AddressID
                this.userProfiledetail.addressLine2 = currentBusinessAddress.AddressLine2
                this.userProfiledetail.addressLine1 = currentBusinessAddress.AddressLine1
                this.userProfiledetail.city = currentBusinessAddress.City
                this.userProfiledetail.state = currentBusinessAddress.State
                this.userProfiledetail.zip = currentBusinessAddress.Zip
                this.userProfiledetail.zip4 = currentBusinessAddress.Zip4
            }

            if (this.userPhones.length > 0) {
                let businessPhone = this.userPhones.filter((phone) => phone.PhoneType === 'Business')[0]
                //   let cellPhone = this.userPhones.filter(phone => phone.PhoneType === 'Cell')[0]
                if (businessPhone) {
                    this.userProfiledetail.phoneNum = Number(businessPhone.Phone)
                    // this.userProfiledetail.PhoneType = businessPhone.PhoneType
                    //  this.userProfiledetail.PhoneTypeID = businessPhone.PhoneTypeID
                    this.businessPhoneID = businessPhone.UserPhoneID
                } else {
                    //this.addDefaultBusinessPhone()
                }
            }
        }
    }
    getUserProfileStatus(retrieveAll: boolean) {
        this.userTypeGateway.getAllUserProfileStatus(false).subscribe((userProfileStatusModel: ValidatedSelectOptionModel[]) => {
            this.userprofileStatus = userProfileStatusModel
        })
    }
    OnUserTypeSelected(userTypeID: number) {
        this.userProfiledetail.RoleID = userTypeID
    }
    onOrgSelectedFromView(org: any) {
        this.OnOrgSelected(org.orgId)
    }
    OnOrgSelected(orgID: number) {
        //document.getElementById('divEmpID').style.display = 'none'
        this.displayEmpID = false
        // orgID = 385
        this.userProfiledetail.OrgID = orgID
        this.setEmpIDValidation(false)
        this.editFmoGateway
            .getOrgSettingValueBySettingName(orgID, 'FMO Settings', 'Marketing Channel')
            .subscribe((orgSettingModel: OrgSettingsModel[]) => {
                if (orgSettingModel !== null && orgSettingModel !== undefined) {
                    if (orgSettingModel.length == 1) {
                        if (orgSettingModel[0].SettingValue === 'Internal' || orgSettingModel[0].SettingValue === 'Internal-Group') {
                            this.displayEmpID = true
                            this.setEmpIDValidation(true)
                            console.log('App Settings for Marketing Type :', orgSettingModel[0].SettingValue)
                        }
                    } else if (orgSettingModel.length > 1) {
                        this.displayEmpID = false
                    }
                }
            })
        this.initialOrgLoad = false
    }

    getOrganizations() {
        this.userTypeGateway.getAllOrganization().subscribe((orgModel: ValidatedSelectOptionModel[]) => {
            this.org = orgModel
            //if (this.userProfiledetail.OrgID === undefined || this.userProfiledetail.OrgID === null) {
            //    this.userProfiledetail.OrgID = ''

            //}
        })
    }
    showTabbed(screen: number) {
        this.commentsScreenShow = false
        this.licenseScreenShow = false
        this.trainingScreenShow = false
        if (screen === 1) {
            this.commentsScreenShow = true
            this.getUserComments()
        }
        if (screen === 3) {
            this.trainingScreenShow = true
        }
        if (screen === 2) {
            this.licenseScreenShow = true
            this.getUserLicense()
        }
    }
    getUserLicense() {
        this.licenseApptGateway.getUserLicenseDetails(this.userProfileID).subscribe((model: License[]) => {
            this.licenseViewModel = model
            this.licenseViewModel.forEach((licenses) => {
                if (licenses.LicenseExpirationDate !== null) {
                    licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentTerminationDate !== null) {
                    licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                }
                if (licenses.AppointmentEffectiveDate !== null) {
                    licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                }

                licenses.EditRow = false
            })
        })
    }
    changePwdNavigation() {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.isAdminUpdate) {
            this.router.navigate(['/' + insCo + '/user-management/update/' + this.userProfiledetail.UserProfileID])
        } else {
            this.router.navigate(['/' + insCo + '/user-management/reset/' + this.userProfiledetail.UserProfileID])
        }
    }
    getUserTypes() {
        this.userTypeGateway.getUserBasedRole().subscribe((userTypemodel: ValidatedSelectOptionModel[]) => {
            this.userType = userTypemodel
            this.userType.unshift({ value: 0, text: '-- Choose One --' })
        })
    }

    getUserTypeDesc(userTypeID: string) {
        this.userTypeDescription = ''
        if (this.userType !== undefined && this.userType !== null) {
            this.userProfiledetail.UserTypeDesc = this.userType.filter((x) => x.value === userTypeID)[0].text

            if (this.userProfiledetail.UserTypeDesc === 'Agent: Marketing' || this.userProfiledetail.UserTypeDesc === 'Admin-Agent') {
                //  this.isRequired = true
            } else {
                //  this.isRequired = false
            }
        }
    }
    submitForm() {
        this.isFormValid = true
        let residentialAddress = {} as AddressDB

        residentialAddress.addressID = this.mode === 'edit' ? this.residentialAddrID : 0 //this.residentialAddress.id
        residentialAddress.addressLine1 = this.userProfiledetail.addressLine1
        residentialAddress.addressLine2 = this.userProfiledetail.addressLine2
        residentialAddress.city = this.userProfiledetail.city
        residentialAddress.state = this.userProfiledetail.state
        residentialAddress.zip = this.userProfiledetail.zip
        //  residentialAddress.zip4 = this.userProfiledetail.zip4
        residentialAddress.addressType = 'Home'

        let businessAddress = {} as AddressDB

        businessAddress.addressID = this.mode === 'edit' ? this.businessAddrID : 0
        businessAddress.addressLine1 = this.userProfiledetail.addressLine1
        businessAddress.addressLine2 = this.userProfiledetail.addressLine2
        businessAddress.city = this.userProfiledetail.city
        businessAddress.state = this.userProfiledetail.state
        businessAddress.zip = this.userProfiledetail.zip
        businessAddress.zip4 = ''
        businessAddress.addressType = 'Business'

        let businessPhone = {} as UserPhoneDB
        if (this.userProfiledetail.phoneNum !== undefined && this.userProfiledetail.phoneNum !== null) {
            businessPhone.Phone = this.userProfiledetail.phoneNum.toString()
        }
        businessPhone.PhoneType = 'Business'
        // this.businessPhone.PhoneType
        businessPhone.PhoneTypeID = 3
        businessPhone.UserPhoneID = this.mode === 'edit' ? this.businessPhoneID : 0

        this.addresses = []
        this.userPhones = []

        this.addresses.push(residentialAddress)
        this.addresses.push(businessAddress)
        this.userPhones.push(businessPhone)

        let personalDetails = {} as UserPersonalDetails
        personalDetails.UserProfileName = this.userProfiledetail.UserProfileName
        personalDetails.LoginPassword = this.userProfiledetail.LoginPassword
        personalDetails.OrgID = this.userProfiledetail.OrgID
        personalDetails.RoleID = this.userProfiledetail.RoleID
        personalDetails.FirstName = this.userProfiledetail.FirstName
        personalDetails.LastName = this.userProfiledetail.LastName
        personalDetails.isNoMidNameChecked = this.userProfiledetail.isNoMidNameChecked
        personalDetails.MiddleName = this.userProfiledetail.MiddleName
        personalDetails.Email = this.userProfiledetail.Email

        this.user.Address = this.addresses
        this.user.UserPhones = this.userPhones
        this.user.PersonalDetails = this.personalDetails
        this.user.UserProfile = this.personalDetails

        this.user.UserProfile.ChangePassword = this.userProfiledetail.ChangePassword

        this.assignFormDatatoUserProfile()
        this.user.UserProfileRoleOrganization = this.userProfileRoleOrganization

        this.successOrErrorMessage = ''

        this.isFormValid = true
        this.Warnings = []
        this.ifWarnings = false
        this.validateForm()
        if (this.isFormValid === true) {
            this.onAddProfile(this.user)
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }
    onAddProfile(user: User) {
        this.focusableEleTop.nativeElement.focus()

        if (this.mode === 'edit') {
            if (this.isAdminUpdate) {
                this.userProfileGateway.updateAdminPersonalDetails(user).subscribe(
                    (model: User) => {
                        this.user = {} as User
                        this.isFormValid = true
                        this.successOrErrorMessage = 'User Profile Updated Successfully'
                    },
                    (error) => {
                        this.successOrErrorMessage = 'An error occured while updating user profile'
                    }
                )
            } else {
                this.userProfileGateway.updateUserProfile(user).subscribe(
                    (model: User) => {
                        this.user = {} as User
                        this.user = model
                        this.isFormValid = true
                        this.successOrErrorMessage = 'User Profile Updated Successfully'
                        if (this.user !== null && this.user !== undefined) {
                            if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                                this.ifWarnings = true
                                this.Warnings = this.user.Warnings
                            }
                        }
                    },
                    (error) => {
                        this.successOrErrorMessage = ''
                        this.ErrorMessages = this.extractErrorMessages(error)
                        this.isFormValid = false
                        this.focusableEleTop.nativeElement.focus()
                    }
                )
            }
        } else {
            this.userProfileGateway.createUserProfile(user).subscribe(
                (model: User) => {
                    this.user = {} as User
                    this.user = model
                    // this.personalDetails = {} as UserPersonalDetails
                    // this.viewUserProfile = {} as UserProfile
                    this.isFormValid = true
                    this.successOrErrorMessage = 'User Profile Created Successfully'
                    if (this.user !== null && this.user !== undefined) {
                        if (this.user.Warnings !== null && this.user.Warnings !== undefined) {
                            this.ifWarnings = true
                            this.Warnings = this.user.Warnings
                        }
                    }
                    const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                    setTimeout(() => {
                        this.router.navigateByUrl('/' + insCo + '/user-management/neje/add-profile/edit/' + model.UserProfile.UserProfileID)
                    }, 5000)
                },
                (error) => {
                    this.successOrErrorMessage = ''
                    this.ErrorMessages = this.extractErrorMessages(error)
                    this.isFormValid = false
                    this.focusableEleTop.nativeElement.focus()
                }
            )
        }
    }

    private extractErrorMessages(error: any): string[] {
        const previousPasswordMessage = 'You cannot use a previous password'

        const mapToDisplayMessages = (messages: string[]): string[] => {
            const normalized = messages.map((m) => String(m || ''))
            const hasPreviousPasswordError = normalized.some(
                (m) => m.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0
            )

            if (hasPreviousPasswordError) {
                return [previousPasswordMessage]
            }

            return normalized
        }

        if (error && error.error) {
            if (Array.isArray(error.error)) {
                return mapToDisplayMessages(error.error)
            }

            if (typeof error.error === 'string') {
                try {
                    const parsed = JSON.parse(error.error)
                    if (Array.isArray(parsed)) {
                        return mapToDisplayMessages(parsed)
                    }
                } catch {
                    if (error.error.length > 0) {
                        if (error.error.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                            return [previousPasswordMessage]
                        }
                        return [error.error]
                    }
                }
            }
        }

        if (error && typeof error.statusText === 'string' && error.statusText.length > 0) {
            try {
                const parsedStatus = JSON.parse(error.statusText)
                if (Array.isArray(parsedStatus)) {
                    return mapToDisplayMessages(parsedStatus)
                }
            } catch {
                if (error.statusText.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                    return [previousPasswordMessage]
                }
                if (error.statusText !== 'Unknown Error') {
                    return [error.statusText]
                }
            }
        }

        return ['Something went wrong, please try again.']
    }

    Cancel() {
        var orgSelected = sessionStorage.getItem('OrgSelected')
        if (this.mode === 'edit') {
            if (orgSelected === 'true') {
                sessionStorage.setItem('editUserOrg', this.userProfiledetail.OrgID.toString())
            }
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.currentUser !== undefined && this.currentUser !== null) {
            if (this.isAdminUpdate) {
                this.router.navigate(['/' + insCo + '/home'])
            } else {
                if (this.isfromUserSearch !== undefined && this.isfromUserSearch) {
                    this.router.navigate(['/' + insCo + '/user-management/user-list'])
                } else {
                    this.router.navigate(['/' + insCo + '/user-management/user-list/user-search'])
                }
            }
        } else {
            this.router.navigate(['/' + insCo + '/home'])
        }
    }
    assignFormDatatoUserProfile() {
        if (this.userProfiledetail.UserProfileName !== '' && this.userProfiledetail.UserProfileName !== undefined) {
            this.user.UserProfile.UserProfileName = this.userProfiledetail.UserProfileName.trim()
        }
        if (this.userProfileRoleOrganization === null || this.userProfileRoleOrganization === undefined)
            this.userProfileRoleOrganization = {} as UserProfileRoleOrganization

        this.userProfileRoleOrganization.OrgID = this.user.UserProfile.OrgID = this.userProfiledetail.OrgID
        this.userProfileRoleOrganization.RoleDefinitionID = this.user.UserProfile.RoleID = this.userProfiledetail.RoleID
        this.user.UserProfile.FirstName = this.userProfiledetail.FirstName
        this.user.UserProfile.LastName = this.userProfiledetail.LastName
        this.user.UserProfile.MiddleName = this.userProfiledetail.MiddleName
        this.user.UserProfile.Email = this.userProfiledetail.Email
        this.user.UserProfile.UID = this.userProfiledetail.UID
        this.user.UserProfile.LoginPassword = this.userProfiledetail.LoginPassword
        this.userProfileRoleOrganization.UserProfileID = this.user.UserProfile.UserProfileID = this.userProfiledetail.UserProfileID
        this.user.UserProfile.UserTypeDesc = this.userProfiledetail.UserTypeDesc
        if (this.userProfiledetail.UserProfileStatusReason != null && this.userProfiledetail.UserProfileStatusReason != undefined) {
            this.user.UserProfile.UserProfileStatusReason = this.userProfiledetail.UserProfileStatusReason
        }
        if (this.userProfiledetail.ProfileStatusDescription != null && this.userProfiledetail.ProfileStatusDescription != undefined) {
            this.user.UserProfile.ProfileStatusDescription = this.userProfiledetail.ProfileStatusDescription
        }

        this.user.UserProfile.UserLoginType = this.validateEmpID ? 'Internal' : 'External'
        if (!this.validateEmpID) {
            this.user.UserProfile.UID = null
            this.userProfiledetail.UID = null
        }
        this.user.UserProfile.UserProfileStatusId = this.userProfiledetail.UserProfileStatusId
    }
    private validateForm() {
        this.ErrorMessages = []
        //if(!this.currentUser.IsSuperAdminAdmin){
        //    if((this.currentUserStatus.toUpperCase() === 'INACTIVE' || this.currentUserStatus.toUpperCase() === 'TERMINATED')
        //        && (this.selectedUserStatus[0].text === 'ACTIVE'))
        //    {
        //        this.isFormValid = false
        //        this.ErrorMessages.push('User Profile Status cannot be changed from ' + this.currentUserStatus + ' to ' + this.selectedUserStatus[0].text + '. Please contact your administrator.')
        //    }
        //}

        if (
            !this._global.currentUser.IsSuperAdminAdmin &&
            !this._global.currentUser.isOrganizationalManager &&
            !this._global.currentUser.isOrganizationalAdmin &&
            !this._global.currentUser.isGroupAdmin &&
            !this._global.currentUser.isCallCenterAdmin
        ) {
            if (this.personalDetails.ProfileStatusDescription === 'Inactive' || this.personalDetails.ProfileStatusDescription === 'Terminated') {
                if (this.currentUserStatus !== this.personalDetails.ProfileStatusDescription) {
                    this.isFormValid = false
                    if (
                        this.userProfiledetail.OrgName !== undefined &&
                        this.userProfiledetail.OrgName !== '' &&
                        this.userProfiledetail.OrgName !== null
                    )
                        this.ErrorMessages.push(
                            'Your role level cannot update the User status you have selected to update. Please contact your ' +
                                this.userProfiledetail.OrgName
                        )
                    else this.ErrorMessages.push('Your role level cannot update the User status you have selected to update. Please contact your. ')
                }
            }
        }
        if (!this.isAdminUpdate) {
            if (
                this.userProfiledetail.UserProfileName !== undefined &&
                this.userProfiledetail.UserProfileName !== null &&
                this.userProfiledetail.UserProfileName !== ''
            ) {
                this.userProfiledetail.UserProfileName = this.userProfiledetail.UserProfileName.trim()
                if (/\s/g.test(this.userProfiledetail.UserProfileName)) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Invalid Login ID')
                }
            } else {
                this.isFormValid = false
                this.ErrorMessages.push('Login ID cannot be blank')
            }
            if (this.mode === 'add') {
                if (
                    this.userProfiledetail.LoginPassword === undefined ||
                    this.userProfiledetail.LoginPassword === null ||
                    this.userProfiledetail.LoginPassword === ''
                ) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Password cannot be blank')
                } else if (
                    this.userProfiledetail.LoginPassword !== undefined &&
                    this.userProfiledetail.LoginPassword !== null &&
                    this.userProfiledetail.LoginPassword !== ''
                ) {
                    if (!this.passwordValidator.isValidPassword(this.userProfiledetail.LoginPassword)) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Password does not meet requirements. Minimum length is 12 characters.')
                        // .va PasswordTextFieldValidator.isValidPassword
                    }
                }
            }
            if (this.userProfiledetail.OrgID === undefined || this.userProfiledetail.OrgID === null || this.userProfiledetail.OrgID === 0) {
                this.isFormValid = false
                this.ErrorMessages.push('Organization cannot be blank')
            }

            if (this.userProfiledetail.RoleID === undefined || this.userProfiledetail.RoleID == 0) {
                this.isFormValid = false
                this.ErrorMessages.push('User Type cannot be blank')
            }
            if (this.validateEmpID) {
                if (this.userProfiledetail.UID === undefined || this.userProfiledetail.UID === '' || this.userProfiledetail.UID === null) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Employee ID cannot be blank')
                }

                if (this.userProfiledetail.UID !== undefined && this.userProfiledetail.UID !== '' && this.userProfiledetail.UID !== null) {
                    if (!this.isValidNumber(this.userProfiledetail.UID)) {
                        this.isFormValid = false
                        this.ErrorMessages.push('Employee ID cannot contain letters or special characters')
                    }
                }
            }
            if (this.userProfiledetail.ProfileStatusDescription === 'Excluded' || this.userProfiledetail.ProfileStatusDescription === 'Terminated') {
                if (this.userProfiledetail.UserProfileStatusReason === undefined || this.userProfiledetail.UserProfileStatusReason === null) {
                    this.isFormValid = false
                    this.ErrorMessages.push('Status Reason cannot be blank')
                }
            }

            var profileOrg = +this.currentUser.orgId
            var profileRole = +this.userProfiledetail.RoleID
            if (this._global.currentUser.IsSuperAdminAdmin) {
                if (profileOrg != this.userProfiledetail.OrgID && profileRole === this.currentUser.roleId) {
                    this.isFormValid = false
                    this.ErrorMessages.push('User Type "Admin: Super" can only be assigned to Blue MedicareRx (PDP) organization')
                }
            } else {
                if (profileOrg === this.userProfiledetail.OrgID && profileRole === this.currentUser.roleId) {
                    this.isFormValid = false
                    if (this.mode === 'add') this.ErrorMessages.push('Your role level cannot create the User Type you have selected to create')
                    else this.ErrorMessages.push('Your role level cannot update the User Type you have selected to update')
                }
            }
            if (this.mode === 'edit') {
                if (
                    this.userProfiledetail.UserProfileStatusId === undefined ||
                    this.userProfiledetail.UserProfileStatusId === null ||
                    this.userProfiledetail.UserProfileStatusId === 0
                ) {
                    this.isFormValid = false
                    this.ErrorMessages.push('User Status cannot be blank')
                }
            }
        }

        if (this.userProfiledetail.FirstName === undefined || this.userProfiledetail.FirstName === null || this.userProfiledetail.FirstName === '') {
            this.isFormValid = false

            this.ErrorMessages.push('First Name cannot be blank')
        }
        if (this.userProfiledetail.LastName === undefined || this.userProfiledetail.LastName === null || this.userProfiledetail.LastName === '') {
            this.isFormValid = false

            this.ErrorMessages.push('Last Name cannot be blank')
        }
        if (this.userProfiledetail.Email === undefined || this.userProfiledetail.Email === null || this.userProfiledetail.Email === '') {
            this.isFormValid = false

            this.ErrorMessages.push('Email cannot be blank')
        }
        if (this.userProfiledetail.phoneNum === undefined || this.userProfiledetail.phoneNum === null) {
            this.isFormValid = false

            this.ErrorMessages.push('Phone number cannot be blank')
        }
        if (this.userProfiledetail.phoneNum.toString().length !== 10) {
            this.ErrorMessages.push('Phone Number must be exactly 10 numbers');
        }
        if (this.userProfiledetail.isNoMidNameChecked === undefined || !this.userProfiledetail.isNoMidNameChecked) {
            if (this.userProfiledetail.MiddleName === undefined || this.userProfiledetail.MiddleName === '') {
                this.isFormValid = false

                this.ErrorMessages.push('Middle Name cannot be blank')
            }
        }
        if (this.userProfiledetail.Email !== undefined && this.userProfiledetail.Email !== null && this.userProfiledetail.Email.trim() !== '') {
            if (!this.isValidEmail(this.userProfiledetail.Email.trim())) {
                this.isFormValid = false
                this.ErrorMessages.push('Email Address is invalid')
            }
        }
        if (
            this.userProfiledetail.addressLine1 === undefined ||
            this.userProfiledetail.addressLine1 === null ||
            this.userProfiledetail.addressLine1 === ''
        ) {
            this.isFormValid = false

            this.ErrorMessages.push('Address1 cannot be blank')
        }
        if (this.userProfiledetail.city === undefined || this.userProfiledetail.city === null || this.userProfiledetail.city === '') {
            this.isFormValid = false

            this.ErrorMessages.push('City cannot be blank')
        }
        if (
            this.userProfiledetail.state === undefined ||
            this.userProfiledetail.state === null ||
            this.userProfiledetail.state === '' ||
            this.userProfiledetail.state === '0' 
        ) {
            this.isFormValid = false
            this.ErrorMessages.push('State cannot be blank')
        }
        if (this.userProfiledetail.zip === undefined || this.userProfiledetail.zip === null || this.userProfiledetail.zip === '') {
            this.isFormValid = false

            this.ErrorMessages.push('Zip cannot be blank')
        }
        if (this.userProfiledetail.zip.length !== 5) {
            this.ErrorMessages.push('Zip must be exactly 5 numbers');
        }
        if (this.userProfiledetail.zip !== undefined && this.userProfiledetail.zip !== '' && this.userProfiledetail.zip !== null) {
            let checkZipCode = this.userProfiledetail.zip,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.isFormValid = false
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }
        if (this.userProfiledetail.phoneNum !== undefined && this.userProfiledetail.phoneNum !== null) {
            let checkOrgPhone = this.userProfiledetail.phoneNum.toString().replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.isFormValid = false
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.isFormValid = false
                }
            }
        }

    }
    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    middlenamecheck() {
        if (
            this.userProfiledetail.MiddleName !== undefined &&
            this.userProfiledetail.MiddleName !== null &&
            this.userProfiledetail.MiddleName !== ''
        ) {
            if (
                this.userProfiledetail.isNoMidNameChecked !== undefined &&
                this.userProfiledetail.isNoMidNameChecked !== null &&
                this.userProfiledetail.isNoMidNameChecked
            ) {
                this.userProfiledetail.isNoMidNameChecked = false
            }
        }
    }

    clickOnMiddleName(val: boolean) {
        this.userProfiledetail.isNoMidNameChecked = val
        this.noMiddleName = this.userProfiledetail.isNoMidNameChecked
        this.userProfiledetail.MiddleName = ''
        //if(this.userProfiledetail.isNoMidNameChecked !== undefined
        //    && this.userProfiledetail.isNoMidNameChecked !== null ){
        //        if (this.userProfiledetail.isNoMidNameChecked) {
        //            //if (this.controlMode === false) {
        //            this.noMiddleName = false
        //            //}
        //
        //        }
        //        else {
        //            //if (this.controlMode === false) {
        //            this.userProfiledetail.MiddleName = ''
        //            this.noMiddleName = true
        //            //}
        //        }
        //    }
        //
    }
    OnStatusChange(listID: number) {
        this.userProfiledetail.UserProfileStatusId = listID
        this.userProfiledetail.ProfileStatusDescription = ''
        this.statusReason = null
        this.selectedUserStatus = this.userprofileStatus.filter((x) => x.value === listID)
        if (this.selectedUserStatus !== undefined) {
            this.userProfiledetail.ProfileStatusDescription = this.selectedUserStatus[0].text
            this.getStatusReason(this.selectedUserStatus[0].text)
        }
    }
    getStatusReason(filter: string) {
        document.getElementById('divStatusreason')!.style.display = 'none'
        this.comLevelGateway.getAllCommissionLevel(filter).subscribe((statusReasonModel: ValidatedSelectOptionModel[]) => {
            this.statusReason = statusReasonModel
            if (statusReasonModel !== undefined || statusReasonModel !== null) {
                if (statusReasonModel.length > 0) {
                    document.getElementById('divStatusreason')!.style.display = 'block'
                }
            }
        })
    }
    getUserComments() {
        this.userCommentsGateway.getUserCommentsData(this.userProfileID).subscribe((model: WebUserComment[]) => {
            this.commentsViewModel = model
            //for (let i = 0; i < this.commentsViewModel.length; i++) {
            //    if (this.commentsViewModel[i].Comment === undefined || this.commentsViewModel[i].Comment === '') {
            //        this.commentsViewModel[i].Comment = 'No comment entered. Comment not save.'
            //    }
            //}
        })
    }
    onCommentAdded(webUserComment: WebUserComment) {
        this.userCommentsGateway.addUsercomments(webUserComment, this.userProfileID).subscribe(
            (model: WebUserComment) => {
                this.CommentinsertModel = model
                this.getUserComments()
            },
            (error) => {
                this.successOrErrorMessage = 'An error occured while saving comments'
                this.getUserComments()
            }
        )
        // this.getUserComments()
    }
}
